module.exports = __webpack_public_path__ + "static/brand_yum_banner-6d8779e5001cc39ab55bbb1cab245635.png";